<template>
	  <div class="site_wrapper">
		<header-area />
		<router-view/>
		<footer-area />
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'App'
}

Vue.component('header-area', () => import('@/components/header'))
Vue.component('footer-area', () => import('@/components/footer'))
</script>

<style lang="scss">
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
/*html,body,div,span,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,abbr,address,cite,code,del,dfn,em,img,ins,kbd,q,samp,small,strong,sub,sup,var,b,i,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,figcaption,figure,footer,header,hgroup,menu,nav,section,summary,time,mark,audio,video {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    vertical-align: baseline;
    background: transparent;
}

body {
    text-transform: none !important;
    background-color: #f6f6f6;
	line-height: 1;
	@media only screen and (max-width: 599px) {
        word-break: break-all;
    }
	
	ul,ol {
		list-style: none;
	}

	select {
		font-size: 1rem;
		padding: 12px 10px 12px 55px;
		box-sizing: border-box;
		-moz-appearance: none;
		-webkit-appearance: none;
		position: relative;
		width: 100%;
		-moz-border-radius: 4px;
		-webkit-border-radius: 4px;
		border-radius: 4px;
		border: 1px solid #D1D1D1;
		z-index: 10;
		font-size: 1rem;
		background: #fff;
		cursor: pointer;
		-moz-transition: all, 0.3s;
		-o-transition: all, 0.3s;
		-webkit-transition: all, 0.3s;
		transition: all, 0.3s;
		height:50px;
	}

	input, select {
		vertical-align: middle;
	}
}*/


</style>



// WEBPACK FOOTER //
// src/App.vue